// Italian strings for TavoloOS
export const t = {
  brand: "TavoloOS",
  tagline: "Il sistema operativo per il tuo ristorante.",
  hero: {
    kicker: "Il tuo ristorante, digitalizzato.",
    title1: "Menu digitale, ordini in sala e pagamenti,",
    title2: "senza attriti.",
    subtitle:
      "TavoloOS è la piattaforma white-label che permette a ristoranti, bar e caffè di offrire un'esperienza di ordinazione moderna via QR — con il tuo brand, i tuoi colori, il tuo menu.",
    cta_primary: "Inizia gratis",
    cta_secondary: "Vedi come funziona",
  },
  nav: {
    features: "Funzioni",
    pricing: "Prezzi",
    login: "Accedi",
    register: "Registrati",
    dashboard: "Dashboard",
    logout: "Esci",
  },
  features: {
    title: "Tutto quello che ti serve. Nulla di superfluo.",
    items: [
      { t: "Menu digitale personalizzato", d: "Categorie, foto, prezzi. Aggiorni tu, in tempo reale." },
      { t: "QR code per ogni tavolo", d: "Stampa e ordina. Il cliente scansiona e ordina dal proprio telefono." },
      { t: "Ordini in cucina live", d: "Ogni ordine arriva istantaneamente al tuo pannello. WebSocket real-time." },
      { t: "Brand tuo, esperienza tua", d: "Logo, colori, tono di voce. La pagina cliente è tua al 100%." },
      { t: "Analytics chiari", d: "Fatturato, scontrino medio, piatti top. Decisioni migliori." },
      { t: "Abbonamenti Stripe", d: "Piani mensili, upgrade e downgrade con un click." },
    ],
  },
  pricing: {
    title: "Piani semplici, prezzi giusti.",
    subtitle: "Nessuna commissione sugli ordini. Nessun contratto lungo.",
    cta: "Scegli",
    per_month: "/mese",
    most_popular: "Più popolare",
  },
  auth: {
    login_title: "Bentornato",
    login_sub: "Accedi al tuo pannello TavoloOS.",
    register_title: "Crea il tuo account",
    register_sub: "Attiva il tuo ristorante in 60 secondi.",
    email: "Email",
    password: "Password",
    name: "Nome",
    restaurant_name: "Nome ristorante",
    submit_login: "Accedi",
    submit_register: "Crea account",
    have_account: "Hai già un account?",
    no_account: "Non hai un account?",
    login_link: "Accedi",
    register_link: "Registrati",
  },
  dash: {
    overview: "Panoramica",
    menu: "Menu",
    tables: "Tavoli",
    orders: "Ordini",
    analytics: "Analytics",
    branding: "Brand",
    subscription: "Abbonamento",
    settings: "Impostazioni",
  },
  admin: {
    title: "Console Piattaforma",
    restaurants: "Ristoranti",
    plans: "Piani",
  },
  customer: {
    menu: "Menu",
    cart: "Carrello",
    add: "Aggiungi",
    remove: "Rimuovi",
    place_order: "Invia ordine",
    order_sent: "Ordine inviato in cucina!",
    my_orders: "I miei ordini",
    total: "Totale",
    empty: "Il carrello è vuoto.",
    table: "Tavolo",
    call_waiter: "Chiama cameriere",
    optional_name: "Il tuo nome (opzionale)",
    notes: "Note",
  },
  common: {
    save: "Salva",
    cancel: "Annulla",
    delete: "Elimina",
    edit: "Modifica",
    add: "Aggiungi",
    close: "Chiudi",
    loading: "Caricamento...",
    empty: "Nessun elemento",
    yes: "Sì",
    no: "No",
    upload_image: "Carica immagine",
    price: "Prezzo",
    description: "Descrizione",
    name: "Nome",
    category: "Categoria",
    available: "Disponibile",
    status: "Stato",
    actions: "Azioni",
  },
  order_status: {
    pending: "In attesa",
    preparing: "In preparazione",
    ready: "Pronto",
    served: "Servito",
    paid: "Pagato",
    cancelled: "Annullato",
  },
};

export function euro(n, currency = "EUR") {
  try {
    return new Intl.NumberFormat("it-IT", { style: "currency", currency }).format(Number(n || 0));
  } catch {
    return `${Number(n || 0).toFixed(2)} €`;
  }
}
